
export const SET_NEWS = "SET_NEWS"